import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO_EN, NAVIGATION_DEMO_KR } from "data/navigation";
import { useLanguage } from '../../contexts/languageContext'

function Navigation() {
  const { language } = useLanguage();

  const NAVIGATION_ITEMS = language === "kr" ? NAVIGATION_DEMO_KR : NAVIGATION_DEMO_EN;

  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {NAVIGATION_ITEMS.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
}

export default Navigation;
